import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { AuthProvider } from "./context/AuthContext";
import { FavoritesProvider } from "./context/FavoritesContext";
import { SubscriptionProvider } from "./context/SubscriptionContext";
import { BookingProvider } from "./context/BookingContext";
import { MessagingProvider } from "./context/MessagingContext";
import { ConsultationProvider } from "./context/ConsultationContext";
import { ReviewsProvider } from "./context/ReviewsContext";
import { PaymentProvider } from "./context/PaymentContext";
import HomePage from "./pages/HomePage";
import ExpertsPage from "./pages/ExpertsPage";
import ExpertProfilePage from "./pages/ExpertProfilePage";
import ExpertReviewsPage from "./pages/ExpertReviewsPage";
import HowItWorksPage from "./pages/HowItWorksPage";
import FavoritesPage from "./pages/FavoritesPage";
import LoginPage from "./pages/auth/LoginPage";
import RegisterPage from "./pages/auth/RegisterPage";
import ClientDashboard from "./pages/dashboard/ClientDashboard";
import ExpertDashboard from "./pages/dashboard/ExpertDashboard";
import PricingPage from "./pages/PricingPage";
import BookingPage from "./pages/BookingPage";
import ExpertSchedulePage from "./pages/dashboard/ExpertSchedulePage";
import AiWorkspace from "./pages/dashboard/AiWorkspace";
import KanbanBoard from "./pages/dashboard/KanbanBoard";
import LorePage from "./pages/dashboard/LorePage";
import AdminPage from "./pages/dashboard/AdminPage";
import MessagesPage from "./pages/MessagesPage";
import EmailPreviewPage from "./pages/EmailPreviewPage";
import ForgotPasswordPage from "./pages/auth/ForgotPasswordPage";
import ResetPasswordPage from "./pages/auth/ResetPasswordPage";
import PaymentResultPage from "./pages/PaymentResultPage";
import ArticlesPage from "./pages/ArticlesPage";
import ArticlePage from "./pages/ArticlePage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import ContactPage from "./pages/ContactPage";
import CookieConsent from "./components/ui/CookieConsent";
import BecomeExpertPage from "./pages/BecomeExpertPage";
import OnboardingPage from "./pages/OnboardingPage";
import ErrorBoundary from "./components/ui/ErrorBoundary";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function RegisterPageWrapper() {
  const location = useLocation();
  return <RegisterPage key={location.search} />;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <FavoritesProvider>
          <SubscriptionProvider>
            <BookingProvider>
              <MessagingProvider>
                <ConsultationProvider>
                  <ReviewsProvider>
                    <PaymentProvider>
                      <ScrollToTop />
                      <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/experts" element={<ExpertsPage />} />
                        <Route path="/experts/:id" element={<ExpertProfilePage />} />
                        <Route path="/experts/:id/reviews" element={<ExpertReviewsPage />} />
                        <Route path="/how-it-works" element={<HowItWorksPage />} />
                        <Route path="/favorites" element={<FavoritesPage />} />
                        <Route path="/pricing" element={<PricingPage />} />
                        <Route path="/booking/:id" element={<BookingPage />} />
                        <Route path="/login" element={<LoginPage />} />
                        <Route path="/register" element={<RegisterPageWrapper />} />
                        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                        <Route path="/reset-password" element={<ResetPasswordPage />} />
                        <Route path="/client/dashboard" element={<ClientDashboard />} />
                        <Route path="/expert/dashboard" element={<ExpertDashboard />} />
                        <Route path="/expert/schedule" element={<ExpertSchedulePage />} />
                        <Route path="/admin" element={<AdminPage />} />
                        <Route path="/messages" element={<MessagesPage />} />
                        <Route path="/email-preview" element={<EmailPreviewPage />} />
                        <Route path="/payment/result" element={<PaymentResultPage />} />
                        <Route path="/articles" element={<ArticlesPage />} />
                        <Route path="/articles/:slug" element={<ArticlePage />} />
                        <Route path="/terms" element={<TermsPage />} />
                        <Route path="/privacy" element={<PrivacyPage />} />
                        <Route path="/contact" element={<ContactPage />} />
                        <Route path="/become-expert" element={<BecomeExpertPage />} />
                        <Route path="/onboarding" element={<OnboardingPage />} />
                        <Route path="/workspace" element={<ErrorBoundary title="AI-Копайлот"><AiWorkspace /></ErrorBoundary>} />
                        <Route path="/workspace/kanban" element={<ErrorBoundary title="Доска задач"><KanbanBoard /></ErrorBoundary>} />
                        <Route path="/workspace/lore" element={<ErrorBoundary title="База знаний"><LorePage /></ErrorBoundary>} />
                      </Routes>
                      <CookieConsent />
                    </PaymentProvider>
                  </ReviewsProvider>
                </ConsultationProvider>
              </MessagingProvider>
            </BookingProvider>
          </SubscriptionProvider>
        </FavoritesProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
